const baseURLs = {
  baseURL: process.env.REACT_APP_API_URL,
  DevAPIURL: "https://localhost:5002",
  API_AUTH_KEY: "PROD-defaultprodtester",
  DevAPIURLPROD: "https://api.qiktruck.co.za",
};
export default baseURLs;
